module.exports = __webpack_public_path__ + "img/invoices_small.b86f5efc.svg";